module.exports = function() {
  return new Worker("./" + "typescript-transpiler.505fe8e6.worker.js");
};